import { render } from "./callToActionSimpleBlock.vue?vue&type=template&id=613645d9&scoped=true&ts=true"
import script from "./callToActionSimpleBlock.vue?vue&type=script&lang=ts"
export * from "./callToActionSimpleBlock.vue?vue&type=script&lang=ts"

import "./callToActionSimpleBlock.vue?vue&type=style&index=0&id=613645d9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-613645d9"]])

export default __exports__